export const SUPPORT_EMAIL = "support@phaze.app";
export const CDN = "https://public.phaze.app";
